import { FC } from "react";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "../../components/PrivateRoute";
import UserTargets from "../../pages/UserTargets";
// import LoginEmailForm from "../../pages/LoginEmailForm";
// import LoginPinForm from "../../pages/LoginPinForm";
import NotFoundPage from "../../pages/NotFound";
import SignUpTargets from "../../pages/SignUpTargets";
// import PasswordPage from "../../pages/Password/index";
// import PasswordSuccess from "../../pages/Password/PasswordSuccessPage";
import RedirectPage from "../../pages/Redirect";

const Router: FC = () => (
  <Switch>
    <PrivateRoute
      exact
      path={"/"}
      component={UserTargets}
      shouldTriggerAuthentication
    />
    <Route exact path={"/sign-up-targets"} component={SignUpTargets} />
    <Route
      exact
      path={"/sign-in"}
      component={() => (
        <RedirectPage url={process.env.REACT_APP_LOGIN_SIGN_UP_FORM_URL} />
      )}
    />
    {/* <Route exact path={"/sign-in/complete"} component={LoginPinForm} />
    <Route exact path={"/password"} component={PasswordPage} />
    <Route exact path={"/password/complete"} component={PasswordSuccess} /> */}
    <Route component={NotFoundPage} />
  </Switch>
);

export default Router;
